import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useOpenCameraButton } from './hooks/useOpenCameraButton';

export const OpenCameraButton: React.FC = () => {
	const {
		actions: { handleButtonClick },
	} = useOpenCameraButton();

	return (
		<Button
			data-testid="create-video"
			data-qa="create-video"
			variant="primary"
			onClick={handleButtonClick}
			className="w-full md:w-1/2"
		>
			<Translate value="corgi.petition_actions.invite.open_camera_button.label" />
		</Button>
	);
};
